import AppEventTarget from "@src/common/events/AppEventTarget";
import ImpersonateEvent from "@src/common/events/ImpersonateEvent";

const USER_KEY = "ImpersonateUser";

export interface ImpersonatedUserData {
  userId: string;
  username: string;
}

export const setImpersonateUser = (user: ImpersonatedUserData | null) => {
  if (user === null) sessionStorage.removeItem(USER_KEY);
  else sessionStorage.setItem(USER_KEY, JSON.stringify(user));
  AppEventTarget.dispatchEvent(new ImpersonateEvent(user));
};

export const getImpersonateUser = (): ImpersonatedUserData | null => {
  const user = JSON.parse(sessionStorage.getItem(USER_KEY) ?? "null");

  if (user === null) {
    return null;
  }

  return user;
};
